module.exports = __webpack_public_path__ + "static/media/alert_active_assailant_selected_hover.1535f94b.svg";